import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { Checkbox, FormControlLabel } from "@mui/material";

import { getAllActiveTerm } from "views/pages/manage/masters/studentFinancials/paymentCollection/DownloadReports/constants";
import SelectMaterialElasticSearch from "../mastersAndMapping/onBoardingMaterialIdSetup/SelectMaterialElasticSearch";
import {
  successToast,
  failureToast,
} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AddToFavourite from "../../../homepage/favourites/AddToFavourite";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { pages } from "../../../common/constant";

import {
  INITIAL_FILTER_STATE,
  packageCodeDropdown,
  inputHeight,
  getMaterialByPackageCode,
  consentReversal,
  ADMIN_ROLE_TYPES,
} from "./helper";

const BulkIssueFilters = ({
  isLoading,
  filters,
  setFilters,
  resetPage,
  eligibleRowsForReversal,
  permissions,
  selectionModel,
  setSelectionModel,
  searchStudentsForMaterials,
  rowData,
}) => {
  const [termDropdown, setTermDropdown] = useState([]);
  const [materialsOptions, setMaterialsOptions] = useState([]);

  const [filterForm, setFilterForm] = useState(INITIAL_FILTER_STATE);

  const { term, batch, categoryDispValue, materialId, isMissingConsent } =
    filterForm;

  useEffect(() => {
    fetchTermDropdown();
  }, []);

  useEffect(() => {
    if (term) {
      setFilterForm({
        ...filterForm,
        batch: "",
        categoryDispValue: "",
        materialId: [],
      });
    }
  }, [term]);

  useEffect(() => {
    if (categoryDispValue?.value) {
      formHandler("materialId", []);

      fetchMaterialsOptions();
    }
  }, [categoryDispValue]);

  const fetchTermDropdown = async () => {
    const termList = await getAllActiveTerm();
    setTermDropdown(termList);
  };

  const fetchMaterialsOptions = async () => {
    const options = await getMaterialByPackageCode({
      packageCode: categoryDispValue?.value,
    });
    setMaterialsOptions(options);
  };

  const formHandler = (name, value) => {
    setFilterForm({ ...filterForm, [name]: value });
  };

  const nextButtonHandler = () => {
    setFilters({ ...filters, ...filterForm });
  };

  const resetButtonHandler = () => {
    setFilterForm(INITIAL_FILTER_STATE);
    setFilters({ ...filters, ...INITIAL_FILTER_STATE });
    resetPage();
  };

  const handleReversal = async () => {
    const selectedRows = (rowData || []).filter((row) =>
      selectionModel.includes(`${row.applicationId}${row.materialId}`)
    );
    const response = await consentReversal(selectedRows);
    if (response.code === 200) {
      successToast(
        `Consent reversal completed for ${selectionModel.length} PSIDs.`
      );
      searchStudentsForMaterials({});
      setSelectionModel([]);
    } else
      failureToast(
        `Consent reversal failed for ${selectionModel.length} PSID(s). Please try again.`
      );
  };

  const isNextDisabled =
    !term?.value ||
    !batch?.length ||
    !categoryDispValue?.value ||
    !materialId?.length;

  return (
    <Card className="mx-4 mb-4 rounded-3 flex-grow-1">
      <CardBody className="p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-xl text-bold">
            Search students for material distribution
          </div>
          <AddToFavourite
            screenName={pages["materialDistribution"]["name"]}
            screenId={pages["materialDistribution"]["id"]}
            className="ml-auto"
            size="md"
          />
        </div>

        <h3 className="mt-3">Bulk Issue</h3>

        <div className="d-flex align-items-center justify-content-between">
          <div className="mr-3 w-100">
            <AAutoComplete
              label="Term*"
              height={inputHeight}
              placeholder="Term"
              items={termDropdown}
              currentValue={term}
              isShowCount={false}
              isMulti={false}
              handleChange={(value) => {
                formHandler("term", value);
              }}
              // isDisabled={disabled}
            />
          </div>

          <div className="mr-3 w-100">
            <SelectMaterialElasticSearch
              label="Batch*"
              currentValue={batch}
              handleChange={(value) => {
                formHandler("batch", value);
              }}
              height={inputHeight}
              isDisabled={!term}
              category="StudentBatches"
              isPlantIdRequired={false}
              filters={{ "term.dispValue": term.label }}
              dropdownMappingParams={["batchName", "id"]}
            />
          </div>

          <div className="mr-3 w-100">
            <AAutoComplete
              label="Pkg. Code*"
              height={inputHeight}
              placeholder="Pkg. Code"
              items={packageCodeDropdown}
              currentValue={categoryDispValue}
              isShowCount={false}
              isMulti={false}
              handleChange={(value) => {
                formHandler("categoryDispValue", value);
              }}
              isDisabled={!batch.length}
            />
          </div>

          <div className="mr-3 w-100">
            <AAutoComplete
              label="Material ID*"
              height={inputHeight}
              items={materialsOptions}
              currentValue={materialId}
              isShowCount={true}
              isMulti={true}
              handleChange={(value) => {
                formHandler("materialId", value);
              }}
              isDisabled={!categoryDispValue}
            />
          </div>
        </div>

        <div className="mt-3 d-flex align-items-center justify-content-between">
          <FormControlLabel
            sx={{
              // marginTop: "-25px",
              "& .MuiFormControlLabel-label": {
                fontSize: "12px",
                marginLeft: "-0.3rem",
              },
            }}
            control={
              <Checkbox
                onChange={(e) =>
                  formHandler("isMissingConsent", e.target.checked)
                }
                checked={isMissingConsent}
                disabled={isNextDisabled}
              />
            }
            label="Show only students with missing consent"
          />

          <div className="d-flex">
            <AButton
              className="button_remove_left_margin"
              updatedStyle={{ fontSize: "14px", flex: "1.75" }}
              onClick={nextButtonHandler}
              variant="primary_filled"
              disabled={isNextDisabled || isLoading}
            >
              Next
            </AButton>
            <AButton
              updatedStyle={{ fontSize: "14px", flex: "0.75" }}
              onClick={resetButtonHandler}
              variant="outline"
              disabled={isLoading}
            >
              Reset
            </AButton>
          </div>
        </div>

        {ADMIN_ROLE_TYPES.includes(permissions.roleType) && (
          <div
            className="bg-orange-50 border border-orange-200 rounded-lg p-3 mt-3"
            style={{ backgroundColor: "#fff7ed", borderColor: "#fed7aa" }}
          >
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center">
                <i
                  className="fas fa-clock"
                  style={{
                    color: "#f97316",
                  }}
                ></i>
                <span
                  className="text-sm text-bold ml-2"
                  style={{ color: "#9a3412" }}
                >
                  Consent Reversal Available ({eligibleRowsForReversal.current}{" "}
                  eligible)
                </span>
              </div>
              <div className="d-flex align-items-center">
                <AButton
                  variant="danger_filled"
                  disabled={selectionModel.length === 0}
                  onClick={handleReversal}
                >
                  Reverse Selected ({selectionModel.length})
                </AButton>
              </div>
            </div>
            <p className="text-xs mb-0" style={{ color: "#ea580c" }}>
              You can reverse consent within 24 hours of capture. After 24
              hours, consent becomes permanent.
            </p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default BulkIssueFilters;
